<template>
	<template v-if="visible">
		<div class="inputs-row fd-lang">
			<input ref="input" type="text" v-model="intlValue" :class="[clazz, errorClass]" 
				   :style="myStyle" :readonly="ro" v-bind="attrs" />
			<select v-model="langValue" v-bind="tabindexBinding(1)" @change="changeLanguage(input,langValue)">
				<option v-for="lang in languages" :value="lang">{{lang}}</option>
			</select>
		</div>
		<span style="padding-left: var(--input-h-padding);/* width: 16px;*/">
			<transition name="fade">
				<sym-icon v-if="completed" name="checkmark-12-bold" style="color: var(--green)" />
			</transition>
		</span>
	</template>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import {computed, ref} from "vue";
import type {IntlItem,IntlInput} from "@t/fd/editor/IntlInput";
import { useBaseIntl } from './IntlBase';
import SymIcon from "@fd/helpers/SymIcon.vue";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const intlInput = computed<IntlInput>(() => props.part as IntlInput);
const intlValues = computed<IntlItem[]>(() => value.value as IntlItem[]);

const {visible, value, clazz, style, ro, errorClass, errorMessage, tabindexBinding} = useEditor(props);

const langValue = ref<string>(null);
const input = ref(null);

const {languages, changeLanguage, initLanguage} = useBaseIntl();

const myStyle = computed<any>(() => {
	const s = style.value;
	if (typeof intlInput.value.size === "number") {
		return [ "max-width: calc("+intlInput.value.size+" * 1ch + 2 * var(--input-h-padding))", s ];
	}
	return s;
});


const intlValue = computed<string>({
	get():string {
		if (Array.isArray(intlValues.value)) {
			let item:IntlItem = getItem(langValue.value);
			if (item) return item.title;
		}
		return '';
	},
	set(v:string):void {
		if (!Array.isArray(intlValues.value)) {
			value.value = [];
		}
		
		let item:IntlItem = getItem(langValue.value);
		if (item) {
			item.title=v;
		}
		else {
			let newItem: IntlItem = {lang: langValue.value,title: v};
			intlValues.value.push(newItem);
		}
	}
});

const completed = computed<boolean>(() => {
	let completed = false;
	if (Array.isArray(intlValues.value)) {
		completed = true;
		languages.value.forEach((lang) => {
			let item:IntlItem = getItem(lang);
			if (!item || !item.title) completed = false;
		});
	}
	return completed;
});


const attrs = computed(() => {
	const a: any = tabindexBinding();
	if (typeof intlInput.value.placeholder === "string") a.placeholder = intlInput.value.placeholder;
	if (typeof intlInput.value.maxLength === "number") a.maxlength = intlInput.value.maxLength;
	//if (typeof intlInput.value.size === "number") a.size = intlInput.value.size;
	const errMsg = errorMessage.value;
	if (errMsg) a.title = errMsg;	// if error put as title
	return a;
});

function getItem(lang: string): IntlItem {
	return intlValues.value.find(item => item.lang === lang);
}

//init actual CRM language
langValue.value = initLanguage();
</script>

<style>
.fd-lang {

	& > select {
		border-left: 1px solid var(--border-color);
		color: var(--footer-bg);
	}
}
</style>

